import { Component } from '@angular/core';
import { NewstrickerviewComponent } from '../../../components/newstrickerview/newstrickerview.component';
import { CommonModule } from '@angular/common';
import { AddNewsComponent } from '../../../components/newstrickerview/add/add.component';

@Component({
  selector: 'app-newstickerwebsiteview',
  imports: [NewstrickerviewComponent, AddNewsComponent, CommonModule],
  templateUrl: './newstickerwebsiteview.component.html',
  styleUrl: './newstickerwebsiteview.component.scss',
})
export class NewstickerwebsiteviewComponent {
  news = [{ id: 1, sentence: 'Website News 2025 🎉' }];
  showCreate = false;

  addNews() {
    alert('Website does not allow creating news!');
  }
  // USER CLICKED "+ Add News"
  handleAdd() {
    this.showCreate = true;
  }

  // CHILD EMITS backtolist
  handleBackToList() {
    this.showCreate = false;
  }
}
